import type { HomeData } from './types';

const HOUR = 3_600_000;

function atDay(now: Date, dayOffset: number, hour: number): Date {
  const d = new Date(now);
  d.setDate(d.getDate() + dayOffset);
  d.setHours(hour, 0, 0, 0);
  return d;
}

/**
 * Données d'exemple de l'Accueil, pour les services qui n'ont pas encore de données (activité,
 * Trésorerie, rappels). Un seul fichier, typé comme le futur contrat réel. Ces valeurs ne quittent jamais le
 * navigateur et ne reproduisent aucun contenu réel : l'interface les marque « Aperçu ».
 */
export function staticHomeData(now: Date, selfInitial: string): HomeData {
  return {
    activity: [
      { id: 'a1', initial: 'M', tone: 'accent', before: 'Marie a modifié ', link: 'Netflix', at: new Date(now.getTime() - 2 * HOUR) },
      { id: 'a2', initial: 'L', tone: 'info', before: 'Léo a coché « ', link: 'Sortir les poubelles', after: ' »', at: atDay(now, -1, 18) },
      { id: 'a3', initial: selfInitial, tone: 'sunken', before: 'Vous avez partagé ', link: 'Wi-Fi maison', at: atDay(now, -4, 10) },
    ],
    treasury: {
      period: 'Solde du mois',
      balance: '1 284,50 €',
      recent: [
        { id: 't1', label: 'Courses', amount: '−68,40 €' },
        { id: 't2', label: 'Électricité', amount: '−54,10 €' },
        { id: 't3', label: 'Remboursement mutuelle', amount: '+25,00 €' },
      ],
    },
    upcoming: [
      { id: 'u1', label: 'Assurance auto', at: atDay(now, 3, 9) },
      { id: 'u2', label: 'Loyer', at: atDay(now, 9, 9) },
    ],
  };
}
